import React, { useMemo } from 'react';

import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Hidden,
} from '@material-ui/core';

import useStyles from './styles';
import { formatMoney } from 'helpers/moneyFormatter';

const Footer = ({ products, onDoRequest }) => {
  const classes = useStyles();

  const totalPrice = useMemo(() => {
    const calculateProductPrice = ({ cart, ...product }) => {
      if (!cart.product_options_request_products.length) {
        return product.price * cart.amount;
      }

      const additionalPrice = cart.product_options_request_products.reduce(
        (acc, aditional) => {
          return acc + aditional.price;
        },
        0,
      );

      return (product.price + additionalPrice) * cart.amount;
    };

    return products.reduce((acc, product) => {
      return (acc += calculateProductPrice(product));
    }, 0);
  }, [products]);

  return (
    <Box className={classes.root}>
      <Container component={Box} p={2}>
        <Grid container>
          <Grid item xs={6}>
            <Typography>Total:</Typography>
            <Typography className={classes.priceTypography}>
              {formatMoney(totalPrice)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Hidden smDown>
                <Button
                  variant="contained"
                  size="large"
                  onClick={onDoRequest}
                  className={classes.cartButton}
                >
                  Fazer Pedido
                </Button>
              </Hidden>
              <Hidden mdUp>
                <Button
                  variant="contained"
                  onClick={onDoRequest}
                  className={classes.cartButton}
                >
                  Fazer Pedido
                </Button>
              </Hidden>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
